// import { useHistory } from "react-router-dom";
// import {
//   country_url,
//   delivery_boy_check_url,
//   delivery_boy_sections_url,
//   delivery_boy_temp_url,
//   state_url,
// } from "../../../api/urls";
// import { useFetch } from "../../../utils/useFetch";
// import { useSteps } from "../../../utils/useStep";
// import { validators } from "../../../utils/zodValidations";
// import { z } from "zod";
// import { useForm } from "react-hook-form";
// import { zodResolver } from "@hookform/resolvers/zod";
// import { Field, FieldSet, Form } from "../../../components/form";
// import { Input } from "../../../components/input";
// import BackButton from "../../../components/BackButton/BackButton";
// import { Header } from "semantic-ui-react";
// import { FormSteps } from "../../../components/formSteps";
// import { api } from "../../../api/api";
// import { serialize } from "../../../utils/serialize";
// import unknownError from "../../../utils/unknownError";
// import { useToast } from "../../../components/Toast";
// import { Fragment, useEffect, useState } from "react";
// import { useParams } from "react-router-dom/cjs/react-router-dom.min";
// import Loading from "../../../components/Loading/Loading";
// import { TitleLine } from "../../../components/lineTitle";

// export function NewPendingRegistration({ edit, view }) {
//   const title = "Add user";
//   const apiUrl = delivery_boy_temp_url;
//   const backUrl = "/logistics/pending_registrations";

//   const { step, setStep, next, canGoToStep } = useSteps(6, {
//     freeMoving: true,
//   });
//   const countryData = useFetch(country_url);
//   const stateData = useFetch(state_url);
//   const history = useHistory();

//   const schemas = [
//     z.object({
//       first_name: validators.stringRequired,
//       last_name: validators.stringRequired,
//       dob: validators.dateRequired,
//       photo: validators.imageRequired,
//       country: validators.numberRequired,
//       mobile_number: validators.numberRequired,
//       email_id: z
//         .string()
//         .optional()
//         .refine(
//           (val) => !val || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
//           "Invalid email",
//         ),
//     }),
//     // .superRefine((values, ctx) => {
//     //   if (countryData?.data) {
//     //     const country = countryData.data.find((c) => c.id === values.country);
//     //     if (
//     //       country?.country_regex &&
//     //       !RegExp(country?.country_regex).test(
//     //         `${country?.country_mobile_code}${values.mobile_number}`
//     //       )
//     //     ) {
//     //       ctx.addIssue({
//     //         message: "Invalid mobile no",
//     //         path: ["mobile_number"],
//     //       });
//     //     }
//     //   }
//     // }),
//     z.object({
//       address: validators.stringRequired,
//       landmark: validators.stringRequired,
//       state: validators.numberRequired,
//       city: validators.stringRequired,
//       country_address: validators.numberRequired,
//       pincode: validators.numberRequired,
//     }),
//     z.object({
//       bank_name: validators.stringRequired,
//       account_holder_name: validators.stringRequired,
//       ifsc_code: validators.stringRequired,
//       acccount_number: validators.stringRequired,
//     }),
//     z.object({ vehicle: validators.stringRequired }),
//     z.any(),
//   ];
//   const methods = useForm({
//     resolver: zodResolver(schemas[step]),
//     shouldFocusError: true,
//   });
//   const [isGetting, setIsGetting] = useState(true);
//   const params = useParams();
//   useEffect(() => {
//     if (edit || view || params.id) {
//       const getData = async () => {
//         try {
//           const res = await api.get(apiUrl + params.id + "/", {
//             headers: { module: module },
//           });
//           const data = res.data?.[0]?.form_data || {};
//           data.id = res.data?.[0]?.id;
//           data.country_mobile_code = data?.mobile_number?.slice(0, 2);
//           data.mobile_number = data?.mobile_number?.slice(2);
//           const documents = [];
//           for (let i = 0; i < Object.keys(data).length; i++) {
//             if (data[`documents[${i}][doc_name]`]) {
//               documents.push({
//                 doc_file: data[`documents[${i}][doc_file]`],
//                 doc_name: data[`documents[${i}][doc_name]`],
//                 doc_type: data[`documents[${i}][doc_type]`],
//                 doc_expiry: data[`documents[${i}][doc_expiry]`],
//                 doc_number: data[`documents[${i}][doc_number]`],
//                 doc_section: data[`documents[${i}][doc_section]`],
//               });
//               delete data[`documents[${i}][doc_name]`];
//               delete data[`documents[${i}][doc_file]`];
//               delete data[`documents[${i}][doc_type]`];
//               delete data[`documents[${i}][doc_expiry]`];
//               delete data[`documents[${i}][doc_number]`];
//               delete data[`documents[${i}][doc_section]`];
//             }
//           }
//           documents.forEach((d) => {
//             data[`${d.doc_name}_number`] = d.doc_number;
//             data[`${d.doc_name}_file`] = d.doc_file;
//             data[`${d.doc_name}_expiry`] = d.doc_expiry;
//           });
//           methods.reset(data);

//           setIsGetting(false);
//         } catch (err) {
//           unknownError(err);
//         }
//       };

//       getData();
//     } else {
//       setIsGetting(false);
//     }
//   }, [params.id, edit, view, methods, apiUrl]);

//   const loading = methods.formState.isSubmitting;
//   const toast = useToast();
//   const fieldData = useFetch(delivery_boy_sections_url);
//   const steps = [
//     {
//       title: "Personal info",
//       onSubmit: async () => {
//         try {
//           const data = methods.getValues();
//           const res = await api.post(delivery_boy_check_url, {
//             mobile_no: `${data.country_mobile_code}${data.mobile_number}`,
//             country: data.country_mobile_code,
//           });
//           if (res.status === 200) {
//             next();
//           } else {
//             toast.open("Mobile number already exists", "error");
//           }
//         } catch (e) {
//           if (e.response.status === 400 && e.response?.data?.data) {
//             toast.open(e.response.data.data, "error");
//           } else {
//             unknownError(e);
//           }
//         }
//       },
//       body: (
//         <FieldSet>
//           <Input.Text
//             methods={methods}
//             label="Name"
//             info="Your first name"
//             name="first_name"
//             placeholder="Enter name"
//             required
//             disabled={view}
//           />
//           <Input.Text
//             methods={methods}
//             label="Last name"
//             info="Your last name"
//             name="last_name"
//             placeholder="Enter last name"
//             required
//             disabled={view}
//           />
//           <Input.Date
//             methods={methods}
//             label="Date of birth"
//             name="dob"
//             placeholder="Enter last name"
//             required
//             showPastDates={true}
//             disabled={view}
//           />
//           <Input.Select
//             methods={methods}
//             label="Country"
//             name="country"
//             placeholder="Select country"
//             options={countryData.data}
//             loading={countryData.loading}
//             onChangeFullData={(d) => {
//               methods.setValue("country_mobile_code", d.country_mobile_code);
//             }}
//             required
//             disabled={view}
//           />
//           <Input.Number
//             methods={methods}
//             label="Mobile no."
//             name="mobile_number"
//             placeholder="Enter mobile number"
//             required
//             disabled={view}
//           />
//           <Input.File
//             methods={methods}
//             label="Upload photo"
//             name="photo"
//             required
//             disabled={view}
//           />
//           <Input.Text
//             methods={methods}
//             label="Email id"
//             name="email_id"
//             type="email"
//             placeholder="Enter your email id"
//             disabled={view}
//           />
//           {!view && (
//             <Field>
//               <div style={{ padding: "10px" }} />
//               <div className="actions">
//                 <button
//                   className="btn-red"
//                   type="button"
//                   onClick={() => {
//                     history.push(backUrl);
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button className="btn" disabled={loading}>
//                   Save
//                 </button>
//               </div>
//             </Field>
//           )}
//         </FieldSet>
//       ),
//     },
//     {
//       title: "Address details",
//       onSubmit: () => {
//         next();
//       },
//       body: (
//         <FieldSet>
//           <Input.Text
//             methods={methods}
//             label="Address"
//             name="address"
//             placeholder="Street | bld | area | plot"
//             required
//             disabled={view}
//           />
//           <Input.Text
//             methods={methods}
//             label="Landmark"
//             name="landmark"
//             placeholder="Enter landmark"
//             required
//             disabled={view}
//           />
//           <Input.Text
//             methods={methods}
//             label="City / town"
//             name="city"
//             placeholder="City / town"
//             disabled={view}
//             required
//           />
//           <Input.Select
//             methods={methods}
//             label="Select state"
//             name="state"
//             placeholder="Select state"
//             options={stateData.data}
//             loading={stateData.loading}
//             required
//             disabled={view}
//           />
//           <Input.Select
//             methods={methods}
//             label="Select country"
//             name="country_address"
//             placeholder="Select country"
//             options={countryData.data}
//             loading={countryData.loading}
//             required
//             disabled={view}
//           />
//           <Input.Number
//             methods={methods}
//             label="Pincode"
//             name="pincode"
//             placeholder="Enter pincode"
//             required
//             disabled={view}
//           />
//           {!view && (
//             <Field>
//               <div style={{ padding: "10px" }} />
//               <div className="actions">
//                 <button
//                   className="btn-red"
//                   type="button"
//                   onClick={() => {
//                     history.push(backUrl);
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button className="btn" disabled={loading}>
//                   Save
//                 </button>
//               </div>
//             </Field>
//           )}
//         </FieldSet>
//       ),
//     },
//     {
//       title: "Bank details",
//       onSubmit: () => {
//         next();
//       },
//       body: (
//         <FieldSet>
//           <Input.Text
//             methods={methods}
//             label="Bank name"
//             name="bank_name"
//             placeholder="Enter bank name"
//             required
//             disabled={view}
//           />
//           <Input.Text
//             methods={methods}
//             label="Account holder name"
//             name="account_holder_name"
//             placeholder="Enter Account holder name"
//             required
//             disabled={view}
//           />
//           <Input.Text
//             methods={methods}
//             label="Account number"
//             name="acccount_number"
//             placeholder="Enter Account number"
//             required
//             disabled={view}
//           />
//           <Input.Text
//             methods={methods}
//             label="IFSC Code"
//             name="ifsc_code"
//             placeholder="Enter IFSC code"
//             required
//             disabled={view}
//           />
//           <Input.Text
//             methods={methods}
//             label="UPI ID"
//             name="upi_id"
//             placeholder="Enter Account number"
//             disabled={view}
//           />
//           {!view && (
//             <Field>
//               <div style={{ padding: "10px" }} />
//               <div className="actions">
//                 <button
//                   className="btn-red"
//                   type="button"
//                   onClick={() => {
//                     history.push(backUrl);
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button className="btn" disabled={loading}>
//                   Save
//                 </button>
//               </div>
//             </Field>
//           )}
//         </FieldSet>
//       ),
//     },
//     {
//       title: "Select vehicle",
//       onSubmit: () => {
//         next();
//       },
//       body: (
//         <FieldSet>
//           <Input.Radio
//             methods={methods}
//             label="Select vehicle"
//             name="vehicle"
//             options={[
//               { id: "Motorcycle", printable_name: "Motorcycle" },
//               { id: "Car", printable_name: "Car" },
//             ]}
//             required
//             disabled={view}
//           />
//           {!view && (
//             <Field>
//               <div style={{ padding: "10px" }} />
//               <div className="actions">
//                 <button
//                   className="btn-red"
//                   type="button"
//                   onClick={() => {
//                     history.push(backUrl);
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button className="btn" disabled={loading}>
//                   Save
//                 </button>
//               </div>
//             </Field>
//           )}
//         </FieldSet>
//       ),
//     },
//     {
//       title: "Upload documents",
//       onSubmit: async () => {
//         const fields = fieldData.data
//           .map((d) => d.docs.map((doc) => ({ ...doc, section: d.section.id })))
//           .flat();
//         const formData = methods.getValues();
//         const data = methods.getValues();
//         const documents = fields.map((field) => {
//           delete data[`${field.doc_name}_number`];
//           delete data[`${field.doc_name}_expiry`];
//           delete data[`${field.doc_name}_file`];
//           return {
//             doc_name: field.doc_name,
//             doc_number: formData[`${field.doc_name}_number`] || "",
//             doc_expiry: formData[`${field.doc_name}_expiry`] || null,
//             doc_file: formData[`${field.doc_name}_file`] || null,
//             doc_type: field.id || null,
//             is_verified: false,
//             doc_kyc: field.doc_kyc,
//             doc_certificate: field.doc_certificate,
//             doc_section: field.section,
//           };
//         });
//         if (edit) {
//           data.mobile_number = `${data.country_mobile_code}${data.mobile_number}`;
//           data.documents = documents;
//           try {
//             const response = await api.patch(
//               `${apiUrl}${data.id}/`,
//               serialize({ form_data: data }),
//             );
//             if (response.status === 200) {
//               toast.open("Edited data successfully", "success");
//               history.push(backUrl);
//             } else {
//               unknownError();
//             }
//           } catch (e) {
//             unknownError();
//           }
//         } else {
//           const data = methods.getValues();
//           data.mobile_number = `${data.country_mobile_code}${data.mobile_number}`;
//           data.documents = documents;
//           try {
//             const response = await api.post(apiUrl, serialize(data));
//             if (response.status === 200) {
//               toast.open("Added data successfully", "success");
//               history.push(backUrl);
//             } else {
//               unknownError();
//             }
//           } catch (e) {
//             unknownError();
//           }
//         }
//       },
//       body: (
//         <>
//           <DocumentSection
//             methods={methods}
//             view={view}
//             fieldData={fieldData}
//           />
//           {!view && (
//             <Field>
//               <div style={{ padding: "10px" }} />
//               <div className="actions">
//                 <button
//                   className="btn-red"
//                   type="button"
//                   onClick={() => {
//                     history.push(backUrl);
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button className="btn" disabled={loading}>
//                   Save
//                 </button>
//               </div>
//             </Field>
//           )}
//         </>
//       ),
//     },
//   ];

//   return (
//     <div>
//       <div id="form">
//         <BackButton href={backUrl} />
//         <Header>{title}</Header>
//       </div>
//       <div style={{ padding: "10px" }} />
//       {isGetting ? (
//         <Loading />
//       ) : (
//         <Form methods={methods} onSubmit={steps[step].onSubmit}>
//           <FormSteps
//             currentStep={step}
//             setCurrentStep={setStep}
//             steps={steps}
//             canGoToStep={canGoToStep}
//             submit={async () => {
//               return true;
//               // if (!view) {
//               //   const valid = await methods.trigger();
//               //   return valid;
//               // } else {
//               //   return true;
//               // }
//             }}
//           />
//         </Form>
//       )}
//     </div>
//   );
// }

// function DocumentSection({ methods, view, fieldData }) {
//   if (fieldData.loading || !fieldData.data) {
//     return <Loading />;
//   }

//   const fields = fieldData?.data?.map((d) => d.docs).flat();

//   return (
//     <>
//       {fieldData.data.map((section) => {
//         if (
//           !section.docs.some((field) => fields.find((f) => f.id === field.id))
//         )
//           return null;
//         return (
//           <FieldSet key={section.section.id}>
//             <TitleLine right>{section.section.printable_name}</TitleLine>
//             <div style={{ padding: "0px" }} />
//             {section.docs.map((field) => {
//               if (!fields.find((f) => f.id === field.id)) return null;
//               const name = field.doc_name;
//               return (
//                 <Fragment key={field.id}>
//                   {field.doc_num_require && (
//                     <Input.Text
//                       methods={methods}
//                       label={`${name} number`}
//                       name={`${name}_number`}
//                       placeholder={`${name} number`}
//                       disabled={view}
//                       required
//                     />
//                   )}
//                   {field.expiryrequire && (
//                     <Input.Date
//                       methods={methods}
//                       label={`${name} expiry`}
//                       name={`${name}_expiry`}
//                       placeholder={`${name} expiry`}
//                       disabled={view}
//                       required
//                     />
//                   )}
//                   {field.filerequire && (
//                     <Input.File
//                       methods={methods}
//                       label={`${name} file`}
//                       name={`${name}_file`}
//                       placeholder={`${name} file`}
//                       disabled={view}
//                       required
//                     />
//                   )}
//                 </Fragment>
//               );
//             })}
//             <div style={{ padding: "5px" }} />
//           </FieldSet>
//         );
//       })}
//     </>
//   );
// }


import { useHistory } from "react-router-dom";
import {
  country_url,
  delivery_boy_check_url,
  delivery_boy_sections_url,
  delivery_boy_temp_url,
  state_url,
} from "../../../api/urls";
import { useFetch } from "../../../utils/useFetch";
import { useSteps } from "../../../utils/useStep";
import {
  InputText,
  InputDate,
  InputNumber,
  InputSelect,
  InputFile,
} from "../../../components/Inputs/Inputs";
import BackButton from "../../../components/BackButton/BackButton";
import { Header } from "semantic-ui-react";
import { FormSteps } from "../../../components/formSteps";
import { FieldSet } from "../../../components/form";
import { api } from "../../../api/api";
import objToFormdata from "../../../utils/objToFormdata";
import unknownError from "../../../utils/unknownError";
import { useToast } from "../../../components/Toast";
import { moveUpToError } from "../../../utils/moveUpToError";
import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Loading from "../../../components/Loading/Loading";
import { TitleLine } from "../../../components/lineTitle";
import { idToname } from "../../../utils/idToname";
import { nameToid } from "../../../utils/nameToid";
import { APIDropdown } from "../../../components/APIDropdown/APIDropdown";
 
const initialState = {
  first_name: "",
  last_name: "",
  dob: "",
  photo: "",
  country: "",
  country_mobile_code: "",
  mobile_number: "",
  email_id: "",
  address: "",
  landmark: "",
  city: "",
  state: "",
  country_address: "",
  pincode: "",
  bank_name: "",
  account_holder_name: "",
  acccount_number: "",
  ifsc_code: "",
  upi_id: "",
  vehicle: "",
};
 
// Per-step required field definitions
const stepRequiredFields = [
  ["first_name", "last_name", "dob", "photo", "country", "mobile_number"],
  ["address", "landmark", "city", "state", "country_address", "pincode"],
  ["bank_name", "account_holder_name", "acccount_number", "ifsc_code"],
  ["vehicle"],
  [], // documents step — validated differently
];
 
const vehicleOptions = ["Motorcycle", "Car"];
 
// ─── Validation helpers ────────────────────────────────────────────────────────
 
/** Returns true if the string contains only numeric digit characters. */
const isDigitsOnly = (v) => /^\d+$/.test(v);
 
function validateStep(data, stepIndex) {
  const errors = {};
 
  // ── Required-field presence check ──────────────────────────────────────────
  for (const field of stepRequiredFields[stepIndex]) {
    if (!data[field] && data[field] !== 0) {
      errors[field] = ["This field is required."];
    }
  }
 
  // ── Step 0 – Personal info ─────────────────────────────────────────────────
  if (stepIndex === 0) {
    // Email format (optional field, validate only when provided)
    if (data.email_id && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email_id)) {
      errors.email_id = ["Invalid email address."];
    }
 
    // Mobile number: digits only, exactly 10 digits
    if (data.mobile_number && !errors.mobile_number) {
      if (!isDigitsOnly(String(data.mobile_number))) {
        errors.mobile_number = ["Mobile number must contain digits only."];
      } else if (String(data.mobile_number).length !== 10) {
        errors.mobile_number = ["Mobile number must be exactly 10 digits."];
      }
    }
  }
 
  // ── Step 1 – Address details ───────────────────────────────────────────────
  if (stepIndex === 1) {
    // Pincode: digits only, exactly 6 digits
    if (data.pincode && !errors.pincode) {
      if (!isDigitsOnly(String(data.pincode))) {
        errors.pincode = ["Pincode must contain digits only."];
      } else if (String(data.pincode).length !== 6) {
        errors.pincode = ["Pincode must be exactly 6 digits."];
      }
    }
  }
 
  // ── Step 2 – Bank details ──────────────────────────────────────────────────
  if (stepIndex === 2) {
    // Account number: digits only, 9–18 digits
    if (data.acccount_number && !errors.acccount_number) {
      const acc = String(data.acccount_number);
      if (!isDigitsOnly(acc)) {
        errors.acccount_number = [
          "Account number must contain digits only (no letters or special characters).",
        ];
      } else if (acc.length < 9) {
        errors.acccount_number = [
          "Account number must be at least 9 digits.",
        ];
      } else if (acc.length > 18) {
        errors.acccount_number = [
          "Account number must not exceed 18 digits.",
        ];
      }
    }
 
    // IFSC code: standard Indian IFSC format — 4 letters, 1 zero, 6 alphanumeric (11 chars total)
    if (data.ifsc_code && !errors.ifsc_code) {
      if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(String(data.ifsc_code).toUpperCase())) {
        errors.ifsc_code = [
          "IFSC code must be 11 characters: 4 letters, a zero, then 6 alphanumeric characters (e.g. SBIN0001234).",
        ];
      }
    }
  }
 
  return errors;
}
 
export function NewPendingRegistration({ edit, view }) {
  const title = "Add user";
  const apiUrl = delivery_boy_temp_url;
  const backUrl = "/logistics/pending_registrations";
 
  const { step, setStep, next, canGoToStep } = useSteps(6, {
    freeMoving: true,
  });
 
  const { data: country } = useFetch(country_url);
  const fieldData = useFetch(delivery_boy_sections_url);
  const history = useHistory();
  const toast = useToast();
  const params = useParams();
 
  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isGetting, setIsGetting] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
 
  const set = (key, value) => {
    setData((d) => ({ ...d, [key]: value }));
    // Clear field error on change
    setErrors((e) => {
      if (!e[key]) return e;
      const next = { ...e };
      delete next[key];
      return next;
    });
  };
 
  useEffect(() => {
    if (edit || view || params.id) {
      const getData = async () => {
        try {
          const res = await api.get(apiUrl + params.id + "/", {
            headers: { module: "module" },
          });
          const raw = res.data?.[0]?.form_data || {};
          raw.id = res.data?.[0]?.id;
 
          // Split stored mobile number into code + number
          raw.country_mobile_code = raw.mobile_number?.slice(0, 2) ?? "";
          raw.mobile_number = raw.mobile_number?.slice(2) ?? "";
 
          // Flatten documents back into keyed fields
          for (let i = 0; i < Object.keys(raw).length; i++) {
            if (raw[`documents[${i}][doc_name]`]) {
              const name = raw[`documents[${i}][doc_name]`];
              raw[`${name}_number`] = raw[`documents[${i}][doc_number]`];
              raw[`${name}_file`] = raw[`documents[${i}][doc_file]`];
              raw[`${name}_expiry`] = raw[`documents[${i}][doc_expiry]`];
              delete raw[`documents[${i}][doc_name]`];
              delete raw[`documents[${i}][doc_file]`];
              delete raw[`documents[${i}][doc_type]`];
              delete raw[`documents[${i}][doc_expiry]`];
              delete raw[`documents[${i}][doc_number]`];
              delete raw[`documents[${i}][doc_section]`];
            }
          }
 
          setData((prev) => ({ ...prev, ...raw }));
          setIsGetting(false);
        } catch (err) {
          unknownError(err);
          setIsGetting(false);
        }
      };
      getData();
    } else {
      setIsGetting(false);
    }
  }, [params.id, edit, view, apiUrl]);
 
  // Validate current step, set errors, return boolean
  const validateCurrentStep = () => {
    const stepErrors = validateStep(data, step);
    if (Object.keys(stepErrors).length > 0) {
      setErrors(stepErrors);
      moveUpToError();
      return false;
    }
    setErrors({});
    return true;
  };
 
  const handleFinalSubmit = async () => {
    if (!validateCurrentStep()) return;
 
    if (!fieldData.data) return;
 
    setIsSaving(true);
    try {
      const fields = fieldData.data
        .map((d) => d.docs.map((doc) => ({ ...doc, section: d.section.id })))
        .flat();
 
      const documents = fields.map((field) => ({
        doc_name: field.doc_name,
        doc_number: data[`${field.doc_name}_number`] || "",
        doc_expiry: data[`${field.doc_name}_expiry`] || null,
        doc_file: data[`${field.doc_name}_file`] || null,
        doc_type: field.id || null,
        is_verified: false,
        doc_kyc: field.doc_kyc,
        doc_certificate: field.doc_certificate,
        doc_section: field.section,
      }));
 
      const payload = {
        ...data,
        mobile_number: `${data.country_mobile_code}${data.mobile_number}`,
        documents,
      };
 
      if (edit) {
        const res = await api.patch(
          `${apiUrl}${data.id}/`,
          objToFormdata({ form_data: payload })
        );
        if (res.status === 200) {
          toast.open("Edited data successfully", "success");
          history.push(backUrl);
        } else {
          unknownError();
        }
      } else {
        const res = await api.post(apiUrl, objToFormdata(payload));
        if (res.status === 200) {
          toast.open("Added data successfully", "success");
          history.push(backUrl);
        } else {
          unknownError();
        }
      }
    } catch (err) {
      if (err.response?.data) {
        setErrors(err.response.data);
        moveUpToError();
      } else {
        unknownError(err);
      }
    } finally {
      setIsSaving(false);
    }
  };
 
  const handleStepNext = async () => {
    if (!validateCurrentStep()) return;
 
    // Step 0: check mobile uniqueness before advancing
    if (step === 0) {
      try {
        const res = await api.post(delivery_boy_check_url, {
          mobile_no: `${data.country_mobile_code}${data.mobile_number}`,
          country: data.country_mobile_code,
        });
        if (res.status === 200) {
          next();
        } else {
          toast.open("Mobile number already exists", "error");
        }
      } catch (e) {
        if (e.response?.status === 400 && e.response?.data?.data) {
          toast.open(e.response.data.data, "error");
        } else {
          unknownError(e);
        }
      }
      return;
    }
 
    next();
  };
 
  const Actions = () =>
    !view ? (
      <div style={{ paddingTop: "10px" }}>
        <div className="actions">
          <button
            className="btn-red"
            type="button"
            onClick={() => history.push(backUrl)}
          >
            Cancel
          </button>
          <button
            className="btn"
            type="button"
            disabled={isSaving}
            onClick={step === 4 ? handleFinalSubmit : handleStepNext}
          >
            {step === 4 ? (isSaving ? "Saving…" : "Save") : "Next"}
          </button>
        </div>
      </div>
    ) : null;
 
  const steps = [
    {
      title: "Personal info",
      body: (
        <FieldSet>
          <InputText
            label="First name"
            placeholder="Enter first name"
            required
            disabled={view}
            value={data.first_name}
            error={errors["first_name"]}
            onChange={(v) => set("first_name", v)}
          />
          <InputText
            label="Last name"
            placeholder="Enter last name"
            required
            disabled={view}
            value={data.last_name}
            error={errors["last_name"]}
            onChange={(v) => set("last_name", v)}
          />
          <InputDate
            label="Date of birth"
            placeholder="Date of birth"
            required
            disabled={view}
            value={data.dob}
            error={errors["dob"]}
            onChange={(v) => set("dob", v)}
            showPastDates={true}
          />
          <InputSelect
            label="Country"
            placeholder="Country"
            required
            disabled={view}
            value={idToname(data.country_mobile_code, country)}
            options={country ? country.map((d) => d.printable_name) : []}
            onChange={(v) => set("country_mobile_code", nameToid(v, country))}
            error={errors["country_mobile_code"]}
          />
          {/* Mobile number — exactly 10 digits */}
          <InputNumber
            label="Mobile no."
            placeholder="Enter 10-digit mobile number"
            required
            disabled={view}
            value={data.mobile_number}
            error={errors["mobile_number"]}
            onChange={(v) => set("mobile_number", v)}
          />
          <InputFile
            label="Upload photo"
            required
            disabled={view}
            value={data.photo}
            error={errors["photo"]}
            onChange={(v) => set("photo", v)}
          />
          <InputText
            label="Email id"
            placeholder="Enter your email id"
            type="email"
            disabled={view}
            value={data.email_id}
            error={errors["email_id"]}
            onChange={(v) => set("email_id", v)}
          />
          <Actions />
        </FieldSet>
      ),
    },
    {
      title: "Address details",
      body: (
        <FieldSet>
          <InputText
            label="Address"
            placeholder="Street | bld | area | plot"
            required
            disabled={view}
            value={data.address}
            error={errors["address"]}
            onChange={(v) => set("address", v)}
          />
          <InputText
            label="Landmark"
            placeholder="Enter landmark"
            required
            disabled={view}
            value={data.landmark}
            error={errors["landmark"]}
            onChange={(v) => set("landmark", v)}
          />
          <InputText
            label="City / town"
            placeholder="City / town"
            required
            disabled={view}
            value={data.city}
            error={errors["city"]}
            onChange={(v) => set("city", v)}
          />
          <APIDropdown
            label="State"
            placeholder="State"
            required
            disabled={view}
            value={data.state}
            url={state_url}
            onChange={(v) => set("state", v)}
            error={errors["state"]}
          />
          <APIDropdown
            label="Country"
            placeholder="Country"
            required
            disabled={view}
            value={data.country_address}
            url={country_url}
            onChange={(v) => set("country_address", v)}
            error={errors["country_address"]}
          />
          {/* Pincode — exactly 6 digits */}
          <InputNumber
            label="Pincode"
            placeholder="Enter 6-digit pincode"
            required
            disabled={view}
            value={data.pincode}
            error={errors["pincode"]}
            onChange={(v) => set("pincode", v)}
          />
          <Actions />
        </FieldSet>
      ),
    },
    {
      title: "Bank details",
      body: (
        <FieldSet>
          <InputText
            label="Bank name"
            placeholder="Enter bank name"
            required
            disabled={view}
            value={data.bank_name}
            error={errors["bank_name"]}
            onChange={(v) => set("bank_name", v)}
          />
          <InputText
            label="Account holder name"
            placeholder="Enter account holder name"
            required
            disabled={view}
            value={data.account_holder_name}
            error={errors["account_holder_name"]}
            onChange={(v) => set("account_holder_name", v)}
          />
          {/* Account number — digits only, 9–18 digits */}
          <InputText
            label="Account number"
            placeholder="Enter account number (9–18 digits)"
            required
            disabled={view}
            value={data.acccount_number}
            error={errors["acccount_number"]}
            onChange={(v) => set("acccount_number", v)}
          />
          {/* IFSC code — 11-char standard format */}
          <InputText
            label="IFSC Code"
            placeholder="e.g. SBIN0001234"
            required
            disabled={view}
            value={data.ifsc_code}
            error={errors["ifsc_code"]}
            onChange={(v) => set("ifsc_code", v.toUpperCase())}
          />
          <InputText
            label="UPI ID"
            placeholder="Enter UPI ID"
            disabled={view}
            value={data.upi_id}
            error={errors["upi_id"]}
            onChange={(v) => set("upi_id", v)}
          />
          <Actions />
        </FieldSet>
      ),
    },
    {
      title: "Select vehicle",
      body: (
        <FieldSet>
          <InputSelect
            label="Select vehicle"
            placeholder="Select vehicle"
            required
            disabled={view}
            value={data.vehicle}
            error={errors["vehicle"]}
            options={vehicleOptions}
            onChange={(v) => set("vehicle", v)}
          />
          <Actions />
        </FieldSet>
      ),
    },
    {
      title: "Upload documents",
      body: (
        <>
          <DocumentSection
            data={data}
            errors={errors}
            set={set}
            view={view}
            fieldData={fieldData}
          />
          <Actions />
        </>
      ),
    },
  ];
 
  return (
    <div>
      <div id="form">
        <BackButton href={backUrl} />
        <Header>{title}</Header>
      </div>
      <div style={{ padding: "10px" }} />
      {isGetting ? (
        <Loading />
      ) : (
        <FormSteps
          currentStep={step}
          setCurrentStep={setStep}
          steps={steps}
          canGoToStep={canGoToStep}
          submit={async () => true}
        />
      )}
    </div>
  );
}
 
function DocumentSection({ data, errors, set, view, fieldData }) {
  if (fieldData.loading || !fieldData.data) {
    return <Loading />;
  }
 
  const allDocs = fieldData.data.map((d) => d.docs).flat();
 
  return (
    <>
      {fieldData.data.map((section) => {
        const hasDocs = section.docs.some((field) =>
          allDocs.find((f) => f.id === field.id)
        );
        if (!hasDocs) return null;
 
        return (
          <FieldSet key={section.section.id}>
            <TitleLine right>{section.section.printable_name}</TitleLine>
            <div style={{ padding: "0px" }} />
            {section.docs.map((field) => {
              if (!allDocs.find((f) => f.id === field.id)) return null;
              const name = field.doc_name;
              return (
                <Fragment key={field.id}>
                  {field.doc_num_require && (
                    <InputText
                      label={`${name} number`}
                      placeholder={`${name} number`}
                      required
                      disabled={view}
                      value={data[`${name}_number`] || ""}
                      error={errors[`${name}_number`]}
                      onChange={(v) => set(`${name}_number`, v)}
                    />
                  )}
                  {field.expiryrequire && (
                    <InputDate
                      label={`${name} expiry`}
                      placeholder={`${name} expiry`}
                      required
                      disabled={view}
                      value={data[`${name}_expiry`] || ""}
                      error={errors[`${name}_expiry`]}
                      onChange={(v) => set(`${name}_expiry`, v)}
                    />
                  )}
                  {field.filerequire && (
                    <InputFile
                      label={`${name} file`}
                      placeholder={`${name} file`}
                      required
                      disabled={view}
                      value={data[`${name}_file`] || ""}
                      error={errors[`${name}_file`]}
                      onChange={(v) => set(`${name}_file`, v)}
                    />
                  )}
                </Fragment>
              );
            })}
            <div style={{ padding: "5px" }} />
          </FieldSet>
        );
      })}
    </>
  );
}